import { useEffect, useState } from "react";
import axios from "axios";
import config from "../configuration/config";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination } from 'swiper';

// swiper bundle styles
import 'swiper/swiper.scss';
import 'swiper/components/pagination/pagination.scss';

// install Swiper modules
SwiperCore.use([Pagination]);

export function AboutHJSection({ subtitle, title, isSlider = false }) {
    const { t: trans, i18n } = useTranslation(["eparts", "info"]);

    let lang = (i18n.language || 'ar');
    const [about, setAbout] = useState([]);

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await axios.request({
                    baseURL: config.controllURL,
                    url: lang + "/api/sections/aboutHj",
                    method: "get",
                });
                if (response.data) {
                    setAbout(response.data);
                }
            } catch (error) {
                console.log(error);
            }
        }
        fetchData();
    }, [lang]);

    return (
        <section className="sec" style={{ paddingTop: 0, paddingBottom: 50 }}>
            <div className="ctn">
                {about?.length > 0 && (
                    <>
                        <div style={{ textAlign: "center", marginBottom: 28 }}>
                            <div className="stag rv" style={{ justifyContent: "center" }}>
                                {subtitle ? subtitle : trans("info:HJ")}
                            </div>
                            <h2 className="sh rv d1">
                                {
                                    (title ? title : trans("eparts:aboutHJ"))
                                        .replace(/<br\s*\/?>/gi, ' ')
                                        .split(' ')
                                        .map((word, i, arr) =>
                                            i >= arr.length - 2 ? (
                                                <span key={i} className="gn"  >
                                                    {word}{' '}
                                                </span>
                                            ) : (
                                                word + ' '
                                            )
                                        )
                                }           </h2>
                        </div>
                        {isSlider ? (
                            <Swiper
                                spaceBetween={8}
                                slidesPerView={2.2}
                                pagination={{ clickable: true }}
                                autoplay={{ delay: 3000, disableOnInteraction: false }}
                                observer={true}
                                observeParents={true}
                                watchSlidesProgress={true}
                                breakpoints={{
                                    480: { slidesPerView: 2.5 },
                                    768: { slidesPerView: 3.5 }
                                }}
                                className="why-swiper"
                            >
                                {about?.filter(item => item.name && item.name.trim())?.map((item, index) => (
                                    <SwiperSlide key={index}>
                                        <div className="why-card rv" style={{ height: '100%', animationDelay: `0.${index + 1}s` }}>
                                            <div className="why-icon">
                                                <img
                                                    src={item.imagePath ? config.FilePathURL + item.imagePath : "/assets/images/default.png"}
                                                    alt={item.name}
                                                    onError={(e) => {
                                                        if (!e.target.dataset.fallback) {
                                                            e.target.dataset.fallback = "1";
                                                            e.target.src = "/assets/images/default.png";
                                                        }
                                                    }}
                                                    style={{ width: "32px", height: "32px", objectFit: "contain" }}
                                                    className="dark-filter-white"
                                                />
                                            </div>
                                            <h3 className="text-18 font-bold mb-3">{item.name}</h3>
                                            <p className="text-14 text-t3 leading-relaxed">{item.content}</p>
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        ) : (
                            <div className="why-grid" style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '20px' }}>
                                {about?.filter(item => item.name && item.name.trim())?.map((item, index) => {
                                    return (
                                        <div className="why-card rv" key={index} style={{ flex: '1 1 250px', maxWidth: '280px', animationDelay: `0.${index + 1}s` }}>
                                            <div className="why-icon">
                                                <img
                                                    src={item.imagePath ? config.FilePathURL + item.imagePath : "/assets/images/default.png"}
                                                    alt={item.name}
                                                    onError={(e) => {
                                                        if (!e.target.dataset.fallback) {
                                                            e.target.dataset.fallback = "1";
                                                            e.target.src = "/assets/images/default.png";
                                                        }
                                                    }}
                                                    style={{ width: "32px", height: "32px", objectFit: "contain" }}
                                                    className="dark-filter-white"
                                                />
                                            </div>
                                            <h3 className="text-18 font-bold mb-3">{item.name}</h3>
                                            <p className="text-14 text-t3 leading-relaxed">{item.content}</p>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </>
                )}
            </div>
        </section>
    );
}
